"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupedBy = void 0;
/**
 * Takes an array of objects and returns an object with a property for each value in the `key` containing an array of all the objects that have that value.
 *
 * @param key The key to group by.
 * @param array The array of objects.
 */
exports.groupedBy = (key, array) => {
    return array.reduce((groups, value) => {
        const k = value[key];
        if (!groups[k])
            groups[k] = [];
        groups[k].push(value);
        return groups;
    }, {});
};
//# sourceMappingURL=grouped-by.js.map